import { TransportManagedByEnum } from '@shared/api/types';
import { SelectOption } from '@shared/components/form/select-form-field';

export const transportManagedByOptions: SelectOption[] = [
  {
    label: 'Managed by us',
    value: TransportManagedByEnum['company'],
  },
  {
    label: 'Managed by client',
    value: TransportManagedByEnum['client'],
  },
  {
    label: 'Outsourced',
    value: TransportManagedByEnum['third_party'],
  },
  {
    label: 'Managed by supplier',
    value: TransportManagedByEnum['supplier'],
  },
  {
    label: 'Downstream',
    value: TransportManagedByEnum['downstream'],
    disabled: true,
  },
];
